import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { LayoutConfigService } from "src/app/core/layout/services/layout-config.service";;



@Component({
  selector: 'app-detran',
  templateUrl: './detran.page.html',
  styleUrls: ['./detran.page.scss'],
})
export class DetranPage implements OnInit {
  billetForm: FormGroup;
  balanceSubject$: string;
  balanceResponse: any;
  iconName: string | 'eye-off-outline' | 'eye-outline';
  showBLC = false;
  titleHeader: string;
  balanceTitle: string;
  backgroundHeaderLogon: string;
  userProfile: any;
  isBarCodeRead: false;


  constructor(
    private layoutConfigService: LayoutConfigService,
    private navController: NavController,
    private router: Router
  ) {
    this.iconName = 'eye-off-outline';
    this.titleHeader = 'CASH_OUT.BILLET.HEADER.TITLE';
    this.balanceTitle = 'CASH_OUT.BILLET.HEADER.SUBTITLE';
    this.backgroundHeaderLogon = this.layoutConfigService.getConfig('wlTheme.header.background.image');
  }

  ngOnInit() {
  }

  goBack() {    
    if (this.router.url === '/app/payment/detran/vehicle-list') {
      this.navController.navigateRoot(['/app/dashboard'])
    } else {
      this.navController.navigateRoot(['/app/payment/detran/vehicle-list'])
    }
  }
}
